'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDeck = createDeck;
exports.deal = deal;

var _utils = require('./utils');

var FULL_DECK = createDeck();

function createDeck() {
  var withoutCards = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var deck = [];
  for (var i = 0; i !== _utils.CARD_VALUES.length; i++) {
    for (var j = 0; j !== _utils.CARD_SUITS.length; j++) {
      var card = _utils.CARD_VALUES[i] + _utils.CARD_SUITS[j];
      if (!withoutCards.includes(card)) {
        deck.push(card);
      }
    }
  }
  return deck;
}

function deal(withoutCards, count) {
  var cards = [];
  while (cards.length !== count) {
    var index = Math.floor(Math.random() * FULL_DECK.length);
    var card = FULL_DECK[index];
    if (!cards.includes(card) && !withoutCards.includes(card)) {
      cards.push(card);
    }
  }
  return cards;
}